// Saves a file the backend has written under /public (e.g. "/invoices/x.pdf")
// straight to the user's Downloads.
//
// Fetched as a blob and saved through a same-origin object URL: opening the
// server URL with window.open after an await is not a user click any more, so
// browsers blocked the tab silently and nothing seemed to happen.
// Every downloaded file is named in capitals (the extension stays as it is):
// "measurement_attachment_18.pdf" -> "MEASUREMENT_ATTACHMENT_18.pdf".
export const upperFileName = (name) => {
  const s = String(name || "").trim();
  const dot = s.lastIndexOf(".");
  return dot > 0 ? s.slice(0, dot).toUpperCase() + s.slice(dot).toLowerCase() : s.toUpperCase();
};

export const downloadServerFile = async (filePath, fileName) => {
  const url = `${process.env.REACT_APP_API_URL}${filePath}`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const fromHeader = /filename="?([^";]+)"?/i.exec(
      res.headers.get("Content-Disposition") || ""
    )?.[1];
    const name =
      fileName || fromHeader || String(filePath).split("/").pop() || "document.pdf";
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = upperFileName(name);
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    return true;
  } catch (e) {
    // last resort: let the browser open it
    window.open(url, "_blank");
    return false;
  }
};
